/**
 * What a DERIVED tenant role may exercise on the client.
 *
 * The client's copy of `DERIVED_TENANT_ROLE_GRANTS` (`@oip/domain`), which the
 * web app cannot import: `@oip/contracts` and `@oip/domain` compile to CommonJS,
 * so this package takes their types and not their runtime values (risk R9) —
 * the same arrangement `requireAuthLanding.ts` and `telemetryOptions.ts` use.
 *
 * It has to exist at all because a derived role is held by somebody with NO
 * membership in the tenant they are working in. A parent administrator inside
 * one of their branches, or a white-label partner administrator inside one of
 * their companies, would otherwise resolve to `role: null` — and every guarded
 * control would vanish from a context the server serves perfectly well, which
 * reads as a broken page rather than as a permission.
 *
 * Its own module rather than a constant inside `AuthProvider.tsx`, so the parity
 * test can import the table itself instead of probing it through `hasRole` with
 * a hand-written list of roles — which is what let `WL_CHILD_ADMIN` be added on
 * the server and missed here.
 */
export const DERIVED_ROLE_GRANTS: Record<string, readonly string[]> = {
  PARENT_CHILD_ADMIN: ['TENANT_ADMIN', 'OPERATIONS_MANAGER', 'OPERATOR', 'VIEWER'],
  /*
   * A white-label partner's administrator, inside a company it owns or a
   * reseller of one. The same grants as a parent administrator, deliberately:
   * the partner may ACT, not only see.
   */
  WL_CHILD_ADMIN: ['TENANT_ADMIN', 'OPERATIONS_MANAGER', 'OPERATOR', 'VIEWER'],
};
